// extracted by mini-css-extract-plugin
module.exports = {"countdownContainer":"CountDown_countdownContainer__3PBvW","countdownUpper":"CountDown_countdownUpper__3XSMK","countdownLower":"CountDown_countdownLower__1EGr5"};